import { Box } from 'src/viewLayer/components/DesignSystem'
import styled from 'styled-components'

export const BackButtonContainer = styled(Box)`
  left: 0;
  position: fixed;
  top: 0.625rem;
`
